const WebConstant = {
    debug: true,
    image: "http://167.71.229.35:2603",
    host: "http://167.71.229.35:2603",
    // image: "http://localhost:2603",
    // host: "http://localhost:2603",
    maxFileSize: 5 * 1000 * 1000,
    // image: "http://167.71.229.35:2603",
    // host: "http://167.71.229.35:2603",
    // maxFileSize: 5 * 1000 * 1000,
};

export default WebConstant;
